/**
 * AuthContext value type and the React context instance.
 *
 * Lives in its own file (separate from `AuthContext.tsx` which exports
 * the `AuthProvider` component) because Vite's react-refresh plugin
 * requires component modules to export ONLY components. The provider,
 * the consumer hook (`useAuth`) and the context object each live in
 * their own module — slightly more files for a clean fast-refresh.
 */
import type { AppAbility } from '@redirector/front/auth/ability';
import type { User } from '@redirector/front/types/types';
import { createContext } from 'react';

export interface AuthContextValue {
  user: User | null;
  token: string | null;
  ability: AppAbility;
  isRootAdmin: boolean;
  isAuthenticated: boolean;
  loading: boolean;
  login: (token: string, user: User) => void;
  logout: () => void;
  refreshUser: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextValue | undefined>(
  undefined,
);
